import * as React from 'react'

import cn from '@config/tailwind/cn'

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div data-slot='skeleton' className={cn('ui:animate-pulse ui:rounded-md ui:bg-grey-30', className)} {...props} />
  )
}

export { Skeleton }
